<template>
  <v-container fluid>
    <v-data-table
      :headers="dessertHeaders"
      :items="others"
      :search="search"
      item-key="id_entrance"

      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Entrance Data</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            solo
            dense
            append-icon="mdi-magnify"
            label="Search Entrance Data"
            class="mr-3 white"
            outlined
            hide-details
          ></v-text-field>
          <v-dialog
            v-model="dialog"
            persistent
            width="800"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="primary"
                v-bind="attrs"
                v-on="on"
              >
                Add New Entrance  <v-icon>{{ icons.mdiPlus }}</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="">
                <span class="text-h6 ">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col md="6">
                    <v-text-field
                      v-model="form.entrance_name"
                      dense
                      outlined
                      placeholder="Entrance Name"
                      label="Entrance Name"
                    />

                    <v-currency-field
                      v-model="form.rate_for_adult"
                      dense
                      prefix="Rp."
                      type="number"
                      outlined
                      placeholder="Rate For Adult"
                      label="Rate For Adult"
                    />

                    <v-currency-field
                      v-model="form.rate_for_child"
                      dense
                      prefix="Rp."
                      type="number"
                      outlined
                      placeholder="Rate For Child"
                      label="Rate For Child"
                    />
                  </v-col>
                  <v-col>
                    <v-textarea
                      v-model="form.note"
                      label="Notes"
                      placeholder="Notes"
                      outlined
                      dense
                      rows="7.5"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  class="text-capitalize"
                  text
                  @click="CekDialog()"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  class="text-capitalize"
                  text
                  @click="Save"
                >
                  {{ TittleButton }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template #[`item.rate_for_adult`]="{ item }">
        Rp. {{ Number(item.rate_for_adult).toLocaleString() }}
      </template>
      <template #[`item.rate_for_child`]="{ item }">
        Rp. {{ Number(item.rate_for_child).toLocaleString() }}
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn
          small
          class="mr-2 text-capitalize primary"
          @click="editItem(item)"
        >
          <v-icon>{{ icons.mdiPencil }}</v-icon>
        </v-btn>
        <v-btn
          small
          class="mr-2 text-capitalize primary"
          @click="deleteItem(item)"
        >
          <v-icon>{{ icons.mdiTrashCan }}</v-icon>
        </v-btn>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Reset
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import numeral from 'numeral'

import axios from 'axios'
import {
  mdiPencil,
  mdiTrashCan,
  mdiPlus,
  mdiClose,
  mdiCalendar,
} from '@mdi/js'

export default {

  data() {
    return {
      rate: 0,
      errors: {},
      icons: {
        mdiPencil,
        mdiTrashCan,
        mdiPlus,
        mdiClose,
        mdiCalendar,
      },
      modal: false,
      modal5: false,
      expanded: [],
      singleExpand: true,
      dialog: false,
      editedIndex: -1,
      search: '',
      form: {
        entrance_name: '',
        id_entrance: '',
        rate_for_adult: '',
        rate_for_child: '',
        note: '',
      },
      service: [],
      dessertHeaders: [
        { text: 'Entrance Name', value: 'entrance_name' },
        { text: 'Rate For Adult', value: 'rate_for_adult' },
        { text: 'Rate For Child', value: 'rate_for_child' },
        { text: 'Note', value: 'note' },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          width: 200,
        },
      ],

      others: [],

    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Add New Entrance' : 'Edit Entrance'
    },
    TittleButton() {
      return this.editedIndex === -1 ? 'Save Entrance' : 'Update Entrance'
    },
  },

  mounted() {
    this.initialize()
  },
  methods: {
    ConvertNumeral() {
      const harga = this.form.rate_for_child
      const string = numeral(harga).format('0,0')
      this.form.rate_for_child = string
    },
    CekDialog() {
      this.form = {
        other_name: '',
        id_other: '',
        rate: '',
        note: '',
      }
      this.dialog = false
    },

    editItem(item) {
      this.editedIndex = this.others.indexOf(item)
      this.form = item
      this.dialog = true
    },
    deleteItem(item) {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/DeleteEntrance', item).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    initialize() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.get('auth/Entrance').then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.others = response.data.data
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    Save() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/SaveEntrance', this.form).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
        this.dialog = false
        this.CekDialog()
        this.editedIndex = -1
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
  },
}
</script>
